import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// 2. Cấu hình Web App Firebase của bạn
const firebaseConfig = {
  apiKey: "AIzaSyBt4RsgeSVTOk-bskgMai7pHW1w-KiX9ug",
  authDomain: "floraison.io.vn",
  databaseURL: "https://floraison-flowers-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "floraison-flowers",
  storageBucket: "floraison-flowers.firebasestorage.app",
  messagingSenderId: "658733875789",
  appId: "1:658733875789:web:cf396344cbf78917399204",
  measurementId: "G-XMQ5MC2ELC"
};

// 3. Khởi tạo Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// 4. Kích hoạt dịch vụ và Export
export const db = getDatabase(app);
export const firestore = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();